'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _get = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _require = require('libp2p-pubsub'),
    utils = _require.utils;

var PeerInfo = require('peer-info');

var BasicPubsub = require('./pubsub');

var _require2 = require('./messageCache'),
    MessageCache = _require2.MessageCache;

var _require3 = require('./message'),
    rpc = _require3.rpc;

var constants = require('./constants');

var Heartbeat = require('./heartbeat');

var GossipSub = /*#__PURE__*/function (_BasicPubsub) {
  _inherits(GossipSub, _BasicPubsub);

  var _super = _createSuper(GossipSub);

  /**
   * @param {PeerInfo} peerInfo instance of the peer's PeerInfo
   * @param {Object} registrar
   * @param {function} registrar.handle
   * @param {function} registrar.register
   * @param {function} registrar.unregister
   * @param {Object} [options]
   * @param {bool} [options.emitSelf] if publish should emit to self, if subscribed, defaults to false
   * @param {bool} [options.gossipIncoming] if incoming messages on a subscribed topic should be automatically gossiped, defaults to true
   * @param {bool} [options.fallbackToFloodsub] if dial should fallback to floodsub, defaults to true
   * @param {function} [options.msgIdFn] override the default message id function
   * @param {Object} [options.messageCache] override the default MessageCache
   * @constructor
   */
  function GossipSub(peerInfo, registrar) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, GossipSub);

    if (!PeerInfo.isPeerInfo(peerInfo)) {
      throw new Error('peer info must be an instance of `peer-info`');
    }

    _this = _super.call(this, {
      debugName: 'libp2p:gossipsub',
      multicodec: constants.GossipSubID,
      peerInfo: peerInfo,
      registrar: registrar,
      options: options
    });
    /**
     * Map of topic meshes
     *
     * @type {Map<string, Set<Peer>>}
     */

    _this.mesh = new Map();
    /**
     * Map of topics to set of peers. These mesh peers are the ones to which we are publishing without a topic membership
     *
     * @type {Map<string, Set<Peer>>}
     */

    _this.fanout = new Map();
    /**
     * Map of last publish time for fanout topics
     *
     * @type {Map<string, Number>}
     */

    _this.lastpub = new Map();
    /**
     * Map of pending messages to gossip
     *
     * @type {Map<Peer, Array<rpc.RPC.ControlIHave object>> }
     */

    _this.gossip = new Map();
    /**
     * Map of control messages
     *
     * @type {Map<Peer, rpc.RPC.ControlMessage object>}
     */

    _this.control = new Map();
    /**
     * Use the overriden mesgIdFn or the default one.
     */

    _this._msgIdFn = options.msgIdFn || _this.defaultMsgIdFn;
    /**
     * A message cache that contains the messages for last few hearbeat ticks
     *
     */

    _this.messageCache = options.messageCache || new MessageCache(constants.GossipSubHistoryGossip, constants.GossipSubHistoryLength, _this._msgIdFn);
    /**
     * A heartbeat timer that maintains the mesh
     */

    _this.heartbeat = new Heartbeat(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Removes a peer from the router
   * @override
   * @param {Peer} peer
   * @returns {PeerInfo}
   */


  _createClass(GossipSub, [{
    key: "_removePeer",
    value: function _removePeer(peer) {
      _get(_getPrototypeOf(GossipSub.prototype), "_removePeer", this).call(this, peer); // Remove this peer from the mesh
      // eslint-disable-next-line no-unused-vars


      var _iterator = _createForOfIteratorHelper(this.mesh.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              _ = _step$value[0],
              peers = _step$value[1];

          peers.delete(peer);
        } // Remove this peer from the fanout
        // eslint-disable-next-line no-unused-vars

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.fanout.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              _2 = _step2$value[0],
              _peers = _step2$value[1];

          _peers.delete(peer);
        } // Remove from gossip mapping

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.gossip.delete(peer); // Remove from control mapping

      this.control.delete(peer);
      return peer;
    }
    /**
     * Handles an rpc control message from a peer
     * @param {Peer} peer
     * @param {rpc.RPC} rpc
     * @returns {void}
     */

  }, {
    key: "_handleRpcControl",
    value: function _handleRpcControl(peer, rpc) {
      var controlMsg = rpc.control;

      if (!controlMsg) {
        return;
      }

      var iWant = this._handleIHave(peer, controlMsg.ihave);

      var iHave = this._handleIWant(peer, controlMsg.iwant);

      var prune = this._handleGraft(peer, controlMsg.graft);

      this._handlePrune(peer, controlMsg.prune);

      if (!iWant || !iHave || !prune) {
        return;
      }

      var outRpc = this._rpcWithControl(iHave, null, iWant, null, prune);

      this._sendRpc(rpc.from, outRpc);
    }
    /**
     * Process incoming message,
     * emitting locally and forwarding on to relevant floodsub and gossipsub peers
     * @param {rpc.RPC.Message} msg
     */

  }, {
    key: "_processRpcMessage",
    value: function _processRpcMessage(msg) {
      var _this2 = this;

      _get(_getPrototypeOf(GossipSub.prototype), "_processRpcMessage", this).call(this, msg);

      var topics = msg.topicIDs; // If options.gossipIncoming is false, do NOT emit incoming messages to peers

      if (!this._options.gossipIncoming) {
        return;
      } // Emit to floodsub peers


      this.peers.forEach(function (peer) {
        if (peer.info.protocols.has(constants.FloodSubID) && peer.info.id.toB58String() !== msg.from && utils.anyMatch(peer.topics, topics) && peer.isWritable) {
          peer.sendMessages(utils.normalizeOutRpcMessages([msg]));

          _this2.log('publish msg on topics - floodsub', topics, peer.info.id.toB58String());
        }
      }); // Emit to peers in the mesh

      topics.forEach(function (topic) {
        if (!_this2.mesh.has(topic)) {
          return;
        }

        _this2.mesh.get(topic).forEach(function (peer) {
          if (!peer.isWritable || peer.info.id.toB58String() === msg.from) {
            return;
          }

          peer.sendMessages(utils.normalizeOutRpcMessages([msg]));

          _this2.log('publish msg on topic - meshsub', topic, peer.info.id.toB58String());
        });
      });
    }
    /**
     * Handles IHAVE messages
     * @param {Peer} peer
     * @param {Array<rpc.RPC.ControlIHave>} ihave
     * @returns {rpc.RPC.ControlIWant}
     */

  }, {
    key: "_handleIHave",
    value: function _handleIHave(peer, ihave) {
      var _this3 = this;

      var iwant = new Set();
      ihave.forEach(function (_ref) {
        var topicID = _ref.topicID,
            messageIDs = _ref.messageIDs;

        if (!_this3.mesh.has(topicID)) {
          return;
        }

        messageIDs.forEach(function (msgID) {
          if (_this3.seenCache.has(msgID)) {
            return;
          }

          iwant.add(msgID);
        });
      });

      if (!iwant.size) {
        return;
      }

      this.log('IHAVE: Asking for %d messages from %s', iwant.size, peer.info.id.toB58String());
      return {
        messageIDs: Array.from(iwant)
      };
    }
    /**
     * Handles IWANT messages
     * Returns messages to send back to peer
     * @param {Peer} peer
     * @param {Array<rpc.RPC.ControlIWant>} iwant
     * @returns {Array<rpc.RPC.Message>}
     */

  }, {
    key: "_handleIWant",
    value: function _handleIWant(peer, iwant) {
      var _this4 = this;

      // @type {Map<string, rpc.RPC.Message>}
      var ihave = new Map();
      iwant.forEach(function (_ref2) {
        var messageIDs = _ref2.messageIDs;
        messageIDs.forEach(function (msgID) {
          var msg = _this4.messageCache.get(msgID);

          if (msg) {
            ihave.set(msgID, msg);
          }
        });
      });

      if (!ihave.size) {
        return;
      }

      this.log('IWANT: Sending %d messages to %s', ihave.size, peer.info.id.toB58String());
      return Array.from(ihave.values());
    }
    /**
     * Handles Graft messages
     * @param {Peer} peer
     * @param {Array<rpc.RPC.ControlGraft>} graft
     * @return {Array<rpc.RPC.ControlPrune>}
     */

  }, {
    key: "_handleGraft",
    value: function _handleGraft(peer, graft) {
      var _this5 = this;

      var prune = [];
      graft.forEach(function (_ref3) {
        var topicID = _ref3.topicID;

        var peers = _this5.mesh.get(topicID);

        if (!peers) {
          prune.push(topicID);
        } else {
          _this5.log('GRAFT: Add mesh link from %s in %s', peer.info.id.toB58String(), topicID);

          peers.add(peer);
          peer.topics.add(topicID);

          _this5.mesh.set(topicID, peers);
        }
      });

      if (!prune.length) {
        return;
      }

      var buildCtrlPruneMsg = function buildCtrlPruneMsg(topic) {
        return {
          topicID: topic
        };
      };

      return prune.map(buildCtrlPruneMsg);
    }
    /**
     * Handles Prune messages
     * @param {Peer} peer
     * @param {Array<rpc.RPC.ControlPrune>} prune
     * @returns {void}
     */

  }, {
    key: "_handlePrune",
    value: function _handlePrune(peer, prune) {
      var _this6 = this;

      prune.forEach(function (_ref4) {
        var topicID = _ref4.topicID;

        var peers = _this6.mesh.get(topicID);

        if (peers) {
          _this6.log('PRUNE: Remove mesh link to %s in %s', peer.info.id.toB58String(), topicID);

          peers.delete(peer);
          peer.topics.delete(topicID);
        }
      });
    }
    /**
     * Mounts the gossipsub protocol onto the libp2p node and sends our
     * our subscriptions to every peer connected
     * @override
     * @returns {Promise}
     */

  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(GossipSub.prototype), "start", this).call(this);

              case 2:
                this.heartbeat.start();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
    /**
     * Unmounts the gossipsub protocol and shuts down every connection
     * @override
     * @returns {Promise}
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _get(_getPrototypeOf(GossipSub.prototype), "stop", this).call(this);

              case 2:
                this.heartbeat.stop();
                this.mesh = new Map();
                this.fanout = new Map();
                this.lastpub = new Map();
                this.gossip = new Map();
                this.control = new Map();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
    /**
     * Join topics
     * @param {Array<string>|string} topics
     * @returns {void}
     */

  }, {
    key: "join",
    value: function join(topics) {
      var _this7 = this;

      if (!this.started) {
        throw new Error('GossipSub has not started');
      }

      topics = utils.ensureArray(topics);
      this.log('JOIN %s', topics);
      topics.forEach(function (topic) {
        // Send GRAFT to mesh peers
        var fanoutPeers = _this7.fanout.get(topic);

        if (fanoutPeers) {
          _this7.mesh.set(topic, fanoutPeers);

          _this7.fanout.delete(topic);

          _this7.lastpub.delete(topic);
        } else {
          var peers = _this7._getPeers(topic, constants.GossipSubD);

          _this7.mesh.set(topic, peers);
        }

        _this7.mesh.get(topic).forEach(function (peer) {
          _this7.log('JOIN: Add mesh link to %s in %s', peer.info.id.toB58String(), topic);

          _this7._sendGraft(peer, topic);
        });
      });
    }
    /**
     * Leave topics
     * @param {Array<string>|string} topics
     * @returns {void}
     */

  }, {
    key: "leave",
    value: function leave(topics) {
      var _this8 = this;

      topics = utils.ensureArray(topics);
      this.log('LEAVE %s', topics);
      topics.forEach(function (topic) {
        // Send PRUNE to mesh peers
        var meshPeers = _this8.mesh.get(topic);

        if (meshPeers) {
          meshPeers.forEach(function (peer) {
            _this8.log('LEAVE: Remove mesh link to %s in %s', peer.info.id.toB58String(), topic);

            _this8._sendPrune(peer, topic);
          });

          _this8.mesh.delete(topic);
        }
      });
    }
    /**
     * Override the default implementation in BasicPubSub.
     * If we don't provide msgIdFn in constructor option, it's the same.
     * @override
     * @param {rpc.RPC.Message} msg the message object
     * @returns {string} message id as string
     */

  }, {
    key: "getMsgId",
    value: function getMsgId(msg) {
      return this._msgIdFn(msg);
    }
  }, {
    key: "_publish",
    value: function _publish(messages) {
      var _this9 = this;

      messages.forEach(function (msgObj) {
        _this9.messageCache.put(msgObj); // @type Set<string>


        var tosend = new Set();
        msgObj.topicIDs.forEach(function (topic) {
          var peersInTopic = _this9.topics.get(topic);

          if (!peersInTopic) {
            return;
          } // floodsub peers


          peersInTopic.forEach(function (peer) {
            if (peer.info.protocols.has(constants.FloodSubID)) {
              tosend.add(peer);
            }
          }); // Gossipsub peers handling

          var meshPeers = _this9.mesh.get(topic);

          if (!meshPeers) {
            // We are not in the mesh for topic, use fanout peers
            meshPeers = _this9.fanout.get(topic);

            if (!meshPeers) {
              // If we are not in the fanout, then pick any peers in topic
              var peers = _this9._getPeers(topic, constants.GossipSubD);

              if (peers.size > 0) {
                meshPeers = peers;

                _this9.fanout.set(topic, peers);
              } else {
                meshPeers = [];
              }
            } // Store the latest publishing time


            _this9.lastpub.set(topic, _this9._now());
          }

          meshPeers.forEach(function (peer) {
            tosend.add(peer);
          });
        }); // Publish messages to peers

        tosend.forEach(function (peer) {
          if (peer.info.id.toB58String() === msgObj.from) {
            return;
          }

          _this9._sendRpc(peer, {
            msgs: [msgObj]
          });
        });
      });
    }
    /**
     * Sends a GRAFT message to a peer
     * @param {Peer} peer
     * @param {String} topic
     * @returns {void}
     */

  }, {
    key: "_sendGraft",
    value: function _sendGraft(peer, topic) {
      var graft = [{
        topicID: topic
      }];

      var out = this._rpcWithControl(null, null, null, graft, null);

      this._sendRpc(peer, out);
    }
    /**
     * Sends a PRUNE message to a peer
     * @param {Peer} peer
     * @param {String} topic
     * @returns {void}
     */

  }, {
    key: "_sendPrune",
    value: function _sendPrune(peer, topic) {
      var prune = [{
        topicID: topic
      }];

      var out = this._rpcWithControl(null, null, null, null, prune);

      this._sendRpc(peer, out);
    }
  }, {
    key: "_sendRpc",
    value: function _sendRpc(peer, outRpc) {
      if (!peer || !peer.isWritable) {
        return;
      } // piggyback control message retries


      var ctrl = this.control.get(peer);

      if (ctrl) {
        this._piggybackControl(peer, outRpc, ctrl);

        this.control.delete(peer);
      } // piggyback gossip


      var ihave = this.gossip.get(peer);

      if (ihave) {
        this._piggybackGossip(peer, outRpc, ihave);

        this.gossip.delete(peer);
      }

      peer.write(rpc.RPC.encode(outRpc));
    }
  }, {
    key: "_piggybackControl",
    value: function _piggybackControl(peer, outRpc, ctrl) {
      var _this10 = this;

      var tograft = (ctrl.graft || []).filter(function (_ref5) {
        var topicID = _ref5.topicID;
        return (_this10.mesh.get(topicID) || new Set()).has(peer);
      });
      var toprune = (ctrl.prune || []).filter(function (_ref6) {
        var topicID = _ref6.topicID;
        return !(_this10.mesh.get(topicID) || new Set()).has(peer);
      });

      if (!tograft.length && !toprune.length) {
        return;
      }

      outRpc.control = outRpc.control || {};
      outRpc.control.graft = (outRpc.control.graft || []).concat(tograft);
      outRpc.control.prune = (outRpc.control.prune || []).concat(toprune);
    }
  }, {
    key: "_piggybackGossip",
    value: function _piggybackGossip(peer, outRpc, ihave) {
      outRpc.control = outRpc.control || {};
      outRpc.control.ihave = ihave;
    }
    /**
     * Send graft and prune messages
     * @param {Map<Peer, Array<String>>} tograft
     * @param {Map<Peer, Array<String>>} toprune
     */

  }, {
    key: "_sendGraftPrune",
    value: function _sendGraftPrune(tograft, toprune) {
      var _iterator3 = _createForOfIteratorHelper(tograft),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              p = _step3$value[0],
              topics = _step3$value[1];

          var graft = topics.map(function (topicID) {
            return {
              topicID: topicID
            };
          });
          var prune = null; // If a peer also has prunes, process them now

          var pruneMsg = toprune.get(p);

          if (pruneMsg) {
            prune = pruneMsg.map(function (topicID) {
              return {
                topicID: topicID
              };
            });
            toprune.delete(p);
          }

          var outRpc = this._rpcWithControl(null, null, null, graft, prune);

          this._sendRpc(p, outRpc);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var _iterator4 = _createForOfIteratorHelper(toprune),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              _p = _step4$value[0],
              _topics = _step4$value[1];

          var _prune = _topics.map(function (topicID) {
            return {
              topicID: topicID
            };
          });

          var _outRpc = this._rpcWithControl(null, null, null, null, _prune);

          this._sendRpc(_p, _outRpc);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
    /**
     * Emits gossip to peers in a particular topic
     * @param {String} topic
     * @param {Set<Peer>} peers - peers to exclude
     * @returns {void}
     */

  }, {
    key: "_emitGossip",
    value: function _emitGossip(topic, peers) {
      var _this11 = this;

      var messageIDs = this.messageCache.getGossipIDs(topic);

      if (!messageIDs.length) {
        return;
      }

      var gossipSubPeers = this._getPeers(topic, constants.GossipSubD);

      gossipSubPeers.forEach(function (peer) {
        // skip mesh peers
        if (!peers.has(peer)) {
          _this11._pushGossip(peer, {
            topicID: topic,
            messageIDs: messageIDs
          });
        }
      });
    }
    /**
     * Flush gossip and control messages
     */

  }, {
    key: "_flush",
    value: function _flush() {
      // send gossip first, which will also piggyback control
      var _iterator5 = _createForOfIteratorHelper(this.gossip.entries()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              peer = _step5$value[0],
              ihave = _step5$value[1];

          this.gossip.delete(peer);

          var out = this._rpcWithControl(null, ihave, null, null, null);

          this._sendRpc(peer, out);
        } // send the remaining control messages

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var _iterator6 = _createForOfIteratorHelper(this.control.entries()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              _peer = _step6$value[0],
              control = _step6$value[1];

          this.control.delete(_peer);

          var _out = this._rpcWithControl(null, null, null, control.graft, control.prune);

          this._sendRpc(_peer, _out);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    /**
     * Adds new IHAVE messages to pending gossip
     * @param {Peer} peer
     * @param {Array<rpc.RPC.ControlIHave>} controlIHaveMsgs
     * @returns {void}
     */

  }, {
    key: "_pushGossip",
    value: function _pushGossip(peer, controlIHaveMsgs) {
      this.log('Add gossip to %s', peer.info.id.toB58String());
      var gossip = this.gossip.get(peer) || [];
      this.gossip.set(peer, gossip.concat(controlIHaveMsgs));
    }
    /**
     * Returns the current time in milliseconds
     * @returns {number}
     */

  }, {
    key: "_now",
    value: function _now() {
      return Date.now();
    }
  }]);

  return GossipSub;
}(BasicPubsub);

module.exports = GossipSub;
module.exports.multicodec = constants.GossipSubID;